import React from "react";
import type { Editor } from "@tiptap/react";
import { Button } from "@/components/ui/button";
import { List, ListOrdered } from "lucide-react";

interface ListGroupProps {
  editor: Editor;
  disabled: boolean;
  onToggleFormat: (format: string) => void;
}

export function ListGroup({ editor, disabled, onToggleFormat }: ListGroupProps) {
  return (
    <>
      <Button
        type="button"
        variant={editor.isActive("bulletList") ? "default" : "ghost"}
        size="sm"
        onClick={() => onToggleFormat("bulletList")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Bullet List"
      >
        <List className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant={editor.isActive("orderedList") ? "default" : "ghost"}
        size="sm"
        onClick={() => onToggleFormat("orderedList")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Numbered List"
      >
        <ListOrdered className="h-4 w-4" />
      </Button>
    </>
  );
}
